
import React, { useState, useEffect } from "react";
import { MobileNav } from './MobileNav';
import { DesktopNav } from './DesktopNav';
import { useLocation } from "react-router-dom";

export const Nav = ({ showNavbar }) => {

    const screenWidthChange = 768;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= screenWidthChange);




    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= screenWidthChange);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <div className={`navmain ${showNavbar ? 'navbar-show' : 'hideNav'}`}>


            {isMobile ? (
                <MobileNav />
            ) : (
                <DesktopNav />
            )}



        </div>
    )
}
